import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { QuickList } from '../interactions/QuickList.jsx'

/**
 * AgreementsCard — session-agreements (catalog #10, non-core).
 *
 * Working norms — simple statements. 'Pinned in next-session sidebar'
 * is v2 sidebar work; not part of Phase F card composition.
 */

export function AgreementsCard({ text = '', onChange, disabled = false }) {
  const items = text ? text.split('\n').filter(Boolean) : []

  function handleChange({ items: next }) {
    onChange?.(next.join('\n'))
  }

  return (
    <CardFrame
      kind="session"
      icon="⚑"
      iconClass="olive"
      title="Agreements"
      prompt="What working norms did you establish?"
      state={disabled ? 'locked' : items.length > 0 ? 'filled' : 'empty'}
      data-testid="session-card-agreements"
      className="session-card"
    >
      <QuickList
        items={items}
        onChange={handleChange}
        maxItems={15}
        readOnly={disabled}
        addLabel="add agreement"
      />
    </CardFrame>
  )
}
